import React from 'react'
import styled from 'styled-components'
import { UtilityDropdownContent, UtilityItemInfo } from '../../styled'
import { useAuthGate } from 'src/components/AuthGate'
import { useUpdateProfilePicMutation } from 'shared/schema'
import { Form, Formik } from 'formik'
import FormField from 'src/components/FormField'
import { useModal } from 'src/components/Modal'
import { useUpload } from 'src/components/Upload'

const SaveError = styled.div`
	color: ${(props) => props.theme.colors.red};
`

function UserDropdownContent() {
	const { setAccessToken, user } = useAuthGate()
	const [profilePicModal, setUpdatingProfilePic] = useModal({
		header: 'Update Profile Picture',
		children: (
			<Formik
				initialValues={{
					file: null
				}}
				onSubmit={async (values, { setStatus }) => {
					setStatus(undefined)
					try {
						const { uploadId } = await upload(values.file.file)

						await updateProfilePic({
							variables: {
								userId: user.id,
								uploadId
							}
						})
					} catch (e) {
						setStatus('Failed to update profile picture. Please try again.')
						return
					}
					setUpdatingProfilePic(false)
				}}
			>
				{({ status }) => (
					<Form>
						<FormField
							name="file"
							type="file"
							label="Update Profile Picture"
							buttonLabel="Upload an image"
							image={{ aspect: 1 }}
						></FormField>
						{status && <SaveError>{status}</SaveError>}
						<FormField type="formButtons" onCancel={() => setUpdatingProfilePic(false)} hideBorderTop />
					</Form>
				)}
			</Formik>
		)
	})
	const [upload] = useUpload()
	const [updateProfilePic] = useUpdateProfilePicMutation()

	const signout = () => {
		setAccessToken(null)
		localStorage.__promptNextLogin = 'yes'
	}

	return (
		<>
			<UtilityDropdownContent>
				<UtilityItemInfo onClick={() => setUpdatingProfilePic(true)}>Update Profile Picture</UtilityItemInfo>
				<UtilityItemInfo onClick={signout}>Logout</UtilityItemInfo>
			</UtilityDropdownContent>
			{profilePicModal}
		</>
	)
}

export default UserDropdownContent
